import React, { Component, PropTypes } from 'react';
import { capitalize } from 'lodash';
import * as queryString from 'query-string';
import { getBookingSocialUser } from 'api';

import './SocialAuthScreen.scss';

class SocialAuthScreen extends Component {

    static propTypes = {
        params: PropTypes.object.isRequired
    }

    state = {
        userData: {}
    }

    constructor(props) {
        super(props);

        var authData = this._getSocialAuthData();
        if (Object.keys(authData).length > 0 && authData.access_token) {
            this._getBookingSocialUser(authData);
        } else {
            window.opener.__onVezetvsemSocialComplete(false);
            window.close();
        }
    }

    _getSocialAuthData = () => {
        return queryString.parse(this.props.location.hash.replace('#', ''));
    }

    _getBookingSocialUser(authData) {
        return getBookingSocialUser(this.props.params.type, authData).then((data) => {
            window.opener.__onVezetvsemSocialComplete(data);
            window.close();
        });
    }
    
    render() {
        return (
            <div className="SocialAuthScreen"/>
        );
    }
}

export default SocialAuthScreen;



// WEBPACK FOOTER //
// ./client/components/SocialAuthScreen/SocialAuthScreen.js